<div class="admin-page">
  <div class="header-card">
    <div>
      <h1>Administração</h1>
      <p>Cadastros auxiliares e variáveis utilizadas pela aplicação.</p>
    </div>
  </div>

  <main class="admin-content">
      <div class="alert erro" *ngIf="erro()">{{ erro() }}</div>
      <div class="alert ok" *ngIf="mensagem()">{{ mensagem() }}</div>

      <ng-container *ngIf="itemAtivo === 'profissionais'">
        <section class="form-card">
          <div class="section-line">
            <div>
              <h2>Cadastro de Peritos, Assistentes Técnicos e Equipe de Apoio</h2>
              <p>Use este cadastro para vincular profissionais às perícias.</p>
            </div>
            <button type="button" class="btn-light" (click)="novo()">Novo cadastro</button>
          </div>

          <div class="form-grid">
            <label>
              <span>Nome</span>
              <input [(ngModel)]="form.nome" placeholder="Nome completo">
            </label>

            <label>
              <span>Tipo</span>
              <select [(ngModel)]="form.tipo">
                <option *ngFor="let tipo of tipos" [value]="tipo">{{ tipo }}</option>
              </select>
            </label>

            <label>
              <span>Registro</span>
              <input [(ngModel)]="form.registro" placeholder="CRC, OAB, matrícula etc.">
            </label>

            <label>
              <span>E-mail</span>
              <input [(ngModel)]="form.email" placeholder="email@dominio.com">
            </label>

            <label>
              <span>Telefone</span>
              <input [(ngModel)]="form.telefone" placeholder="(00) 00000-0000">
            </label>

            <label>
              <span>Status</span>
              <select [(ngModel)]="form.status">
                <option *ngFor="let status of statusOpcoes" [value]="status">{{ status }}</option>
              </select>
            </label>

            <label class="wide">
              <span>Observações</span>
              <textarea rows="3" [(ngModel)]="form.observacoes"></textarea>
            </label>
          </div>

          <div class="actions">
            <button type="button" class="btn-light" (click)="novo()">Limpar</button>
            <button type="button" class="btn-primary" (click)="salvar()">{{ editandoId ? 'Salvar alteração' : 'Cadastrar' }}</button>
          </div>
        </section>

        <section class="table-card">
          <div class="table-title">
            <h2>Profissionais cadastrados</h2>
            <span>{{ profissionais().length }} registro(s)</span>
          </div>

          <div class="prof-table">
            <div class="prof-head">
              <div>Nome</div><div>Tipo</div><div>Registro</div><div>E-mail</div><div>Status</div><div>Ações</div>
            </div>

            <div class="prof-row" *ngFor="let p of profissionais()">
              <div><strong>{{ p.nome }}</strong></div>
              <div>{{ p.tipo }}</div>
              <div>{{ p.registro }}</div>
              <div>{{ p.email }}</div>
              <div><span class="pill">{{ p.status }}</span></div>
              <div class="row-actions">
                <button type="button" class="btn-mini" (click)="editar(p)">Editar</button>
                <button type="button" class="btn-mini danger" (click)="excluir(p)">Excluir</button>
              </div>
            </div>
          </div>
        </section>
      </ng-container>

      <ng-container *ngIf="itemAtivo === 'variaveis'">
        <section class="form-card">
          <div class="section-line">
            <div>
              <h2>Configurações e Variáveis da Aplicação</h2>
              <p>Cadastre variáveis reutilizáveis, como diretório de retorno de planilhas e outros parâmetros.</p>
            </div>
            <button type="button" class="btn-light" (click)="novaVariavel()">Nova variável</button>
          </div>

          <div class="variavel-grid">
            <label>
              <span>Nome da variável</span>
              <input [(ngModel)]="variavelForm.nome" placeholder="Ex.: Diretório de retorno de planilhas">
            </label>

            <label>
              <span>Chave técnica</span>
              <input [(ngModel)]="variavelForm.chave" placeholder="Ex.: diretorio_retorno_planilha">
            </label>

            <label>
              <span>Valor</span>
              <input [(ngModel)]="variavelForm.valor" placeholder="Ex.: C:\\tmp\\peritodesk\\retornos">
            </label>

            <label class="wide">
              <span>Descrição</span>
              <textarea rows="3" [(ngModel)]="variavelForm.descricao" placeholder="Explique para que esta variável será usada"></textarea>
            </label>
          </div>

          <div class="actions">
            <button type="button" class="btn-light" (click)="novaVariavel()">Limpar</button>
            <button type="button" class="btn-primary" (click)="salvarVariavel()">
              {{ variavelEditandoIndex === null ? 'Cadastrar variável' : 'Salvar variável' }}
            </button>
          </div>
        </section>

        <section class="table-card">
          <div class="table-title">
            <h2>Variáveis cadastradas</h2>
            <span>{{ configuracao.variaveis.length }} registro(s)</span>
          </div>

          <div class="var-table">
            <div class="var-head">
              <div>Nome</div><div>Chave</div><div>Valor</div><div>Descrição</div><div>Ações</div>
            </div>

            <div class="var-row" *ngFor="let v of configuracao.variaveis; let i = index">
              <div><strong>{{ v.nome }}</strong></div>
              <div><code>{{ v.chave }}</code></div>
              <div>{{ v.valor }}</div>
              <div>{{ v.descricao }}</div>
              <div class="row-actions">
                <button type="button" class="btn-mini" (click)="editarVariavel(i)">Editar</button>
                <button type="button" class="btn-mini danger" (click)="excluirVariavel(i)">Excluir</button>
              </div>
            </div>
          </div>
        </section>
      </ng-container>

<ng-container *ngIf="itemAtivo === 'rotinas'">
  <section class="form-card">
    <div class="section-line">
      <div>
        <h2>Rotinas Analíticas</h2>
        <p>Cadastro administrativo de procedimentos reutilizáveis. Nas perícias, a aba Execuções apenas escolhe uma rotina.</p>
      </div>
      <button type="button" class="btn-light" (click)="novaRotina()">Nova rotina</button>
    </div>

    <div class="rotina-grid">
      <label>
        <span>Nome da rotina</span>
        <input [(ngModel)]="rotinaForm.nome" placeholder="Ex.: Cruzamento de valores">
      </label>

      <label>
        <span>Tipo</span>
        <select [(ngModel)]="rotinaForm.tipo">
          <option>Documental</option>
          <option>Contábil/Financeiro</option>
          <option>Cálculo</option>
          <option>Dados</option>
          <option>Analítica</option>
          <option>Geral</option>
        </select>
      </label>

      <label class="check-inline">
        <input type="checkbox" [(ngModel)]="rotinaForm.ativo">
        <span>Ativa</span>
      </label>

      <label class="wide">
        <span>Objetivo</span>
        <textarea rows="3" [(ngModel)]="rotinaForm.objetivo" placeholder="Objetivo da rotina analítica"></textarea>
      </label>

      <label class="wide">
        <span>Entrada esperada</span>
        <textarea rows="3" [(ngModel)]="rotinaForm.entrada_esperada" placeholder="Quais dados, documentos ou bases esta rotina usa"></textarea>
      </label>

      <label class="wide">
        <span>Procedimento padrão</span>
        <textarea rows="3" [(ngModel)]="rotinaForm.procedimento" placeholder="Como o procedimento deve ser executado"></textarea>
      </label>

      <label class="wide">
        <span>Critério de achado</span>
        <textarea rows="3" [(ngModel)]="rotinaForm.criterio_achado" placeholder="Quando a execução deve gerar achado"></textarea>
      </label>

      <label class="wide">
        <span>Saída esperada</span>
        <textarea rows="3" [(ngModel)]="rotinaForm.saida_esperada" placeholder="Resumo, achados, evidências ou relatório esperado"></textarea>
      </label>
    </div>

    <div class="actions">
      <button type="button" class="btn-light" (click)="novaRotina()">Limpar</button>
      <button type="button" class="btn-primary" (click)="salvarRotina()">
        {{ rotinaEditandoId ? 'Salvar rotina' : 'Cadastrar rotina' }}
      </button>
    </div>
  </section>

  <section class="table-card">
    <div class="table-title">
      <h2>Biblioteca de rotinas analíticas</h2>
      <span>{{ rotinasAnaliticas().length }} registro(s)</span>
    </div>

    <div class="rotina-table">
      <div class="rotina-head">
        <div>ID</div><div>Nome</div><div>Tipo</div><div>Ativa</div><div>Objetivo</div><div>Ações</div>
      </div>

      <div class="rotina-row" *ngFor="let r of rotinasAnaliticas()" [class.inativa]="r.ativo === false">
        <div>{{ r.id }}</div>
        <div><strong>{{ r.nome || ('Rotina ' + r.id) }}</strong></div>
        <div>{{ r.tipo }}</div>
        <div><span class="pill">{{ r.ativo === false ? 'Não' : 'Sim' }}</span></div>
        <div>{{ r.objetivo }}</div>
        <div class="row-actions">
          <button type="button" class="btn-mini" (click)="editarRotina(r)">Editar</button>
          <button type="button" class="btn-mini" (click)="alternarRotina(r)">
            {{ r.ativo === false ? 'Ativar' : 'Inativar' }}
          </button>
          <button type="button" class="btn-mini danger" (click)="excluirRotina(r)">Excluir</button>
        </div>
      </div>
    </div>
  </section>
</ng-container>

      <ng-container *ngIf="itemAtivo === 'indicadores-economicos'">
        <section class="form-card">
          <div class="section-line">
            <div>
              <h2>Indicadores Econômicos</h2>
              <p>Consulta, valores e importação dos índices BCB/SGS usados na atualização monetária.</p>
            </div>

            <div class="row-actions">
              <button type="button" class="btn-light" (click)="carregarIndicadoresEconomicos()">
                {{ indicadoresCarregando ? 'Carregando...' : 'Atualizar lista' }}
              </button>

              <button type="button" class="btn-primary" (click)="importarIndicadoresBcb()" [disabled]="importacaoIndicadoresCarregando">
                {{ importacaoIndicadoresCarregando ? 'Importando...' : 'Atualizar indicadores BCB/SGS' }}
              </button>
            </div>
          </div>

          <div class="abas-indicadores">
            <button type="button" [class.ativa]="abaIndicadores === 'resumo'" (click)="abaIndicadores = 'resumo'">
              Resumo
            </button>
            <button type="button" [class.ativa]="abaIndicadores === 'valores'" (click)="abaIndicadores = 'valores'">
              Valores
            </button>
            <button type="button" [class.ativa]="abaIndicadores === 'importacao'" (click)="abaIndicadores = 'importacao'">
              Importação BCB
            </button>
          </div>

          <div class="indicadores-filtros" *ngIf="abaIndicadores === 'valores'">
            <label>
              <span>Código do indicador</span>
              <select [(ngModel)]="indicadorCodigoSelecionado" (change)="carregarValoresIndicador()">
                <option value="">Selecione um indicador</option>
                <option *ngFor="let i of indicadoresEconomicos()" [value]="i.codigo">
                  {{ i.codigo }} - {{ i.nome }} - {{ periodicidadeIndicador(i) }}
                </option>
              </select>
            </label>

            <div class="indicador-resumo-box" *ngIf="indicadorCodigoSelecionado">
              Indicador selecionado:
              <strong>{{ indicadorCodigoSelecionado }}</strong>
            </div>
          </div>
        </section>

        <section class="table-card" *ngIf="abaIndicadores === 'resumo'">
          <div class="table-title">
            <h2>Resumo dos indicadores</h2>
            <span>{{ indicadoresEconomicos().length }} indicador(es)</span>
          </div>

          <div class="indicadores-mini-resumo">
            <div>
              <label>Última carga correta</label>
              <strong>{{ ultimaImportacaoResumo() }}</strong>
            </div>
            <div>
              <label>Total de indicadores</label>
              <strong>{{ indicadoresEconomicos().length }}</strong>
            </div>
          </div>

          <div class="indicadores-table">
            <div class="indicadores-head indicadores-grid-resumo">
              <div>Código</div>
              <div>Nome</div>
              <div>Periodicidade</div>
              <div>Fonte</div>
              <div>Qtd.</div>
              <div>Última competência</div>
              <div>Último valor</div>
              <div>Status</div>
            </div>

            <div
              class="indicadores-row indicadores-grid-resumo"
              *ngFor="let i of indicadoresEconomicos()"
              [class.indicador-selecionado]="i.codigo === indicadorCodigoSelecionado"
              (click)="selecionarIndicadorResumo(i.codigo)"
              title="Clique para ver os valores deste indicador"
            >
              <div><strong>{{ i.codigo }}</strong></div>
              <div>{{ i.nome }}</div>
              <div>{{ periodicidadeIndicador(i) }}</div>
              <div>{{ i.fonte }} {{ i.codigo_fonte }}</div>
              <div>{{ i.qtd_valores }}</div>
              <div>{{ formatarDataIndicador(i.ultima_competencia) }}</div>
              <div>{{ formatarPercentualIndicador(i.ultimo_valor_percentual) }}</div>
              <div><span class="pill">{{ i.status }}</span></div>
            </div>
          </div>

          <div class="vazio" *ngIf="!indicadoresCarregando && indicadoresEconomicos().length === 0">
            Nenhum indicador econômico encontrado.
          </div>
        </section>

        <section class="table-card" *ngIf="abaIndicadores === 'valores'">
          <div class="table-title">
            <h2>Valores do indicador</h2>
            <span *ngIf="indicadorCodigoSelecionado">{{ indicadorCodigoSelecionado }} - {{ indicadorValores().length }} registro(s)</span>
          </div>

          <div class="alert" *ngIf="!indicadorCodigoSelecionado">
            Selecione um indicador na aba Resumo ou escolha um código acima para visualizar os valores importados.
          </div>

          <div class="alert ok" *ngIf="indicadorValoresCarregando">
            Carregando valores do indicador...
          </div>

          <div class="indicadores-table" *ngIf="indicadorCodigoSelecionado && !indicadorValoresCarregando">
            <div class="indicadores-head indicadores-grid-valores">
              <div>Competência</div>
              <div>Valor %</div>
              <div>Fator mensal</div>
              <div>Importado em</div>
            </div>

            <div class="indicadores-row indicadores-grid-valores" *ngFor="let v of indicadorValores()">
              <div>{{ formatarDataIndicador(v.competencia) }}</div>
              <div>{{ formatarPercentualIndicador(v.valor_percentual) }}</div>
              <div>{{ formatarFatorIndicador(v.fator_mensal) }}</div>
              <div>{{ formatarDataHoraIndicador(v.importado_em) }}</div>
            </div>
          </div>

          <div class="vazio" *ngIf="indicadorCodigoSelecionado && !indicadorValoresCarregando && indicadorValores().length === 0">
            Nenhum valor encontrado para o indicador selecionado.
          </div>
        </section>

        <section class="table-card" *ngIf="abaIndicadores === 'importacao'">
          <div class="table-title">
            <h2>Importação BCB/SGS</h2>
            <span>Execução e histórico da última carga</span>
          </div>

          <div class="indicadores-mini-resumo">
            <div>
              <label>Última carga correta pela base</label>
              <strong>{{ ultimaImportacaoResumo() }}</strong>
            </div>
            <div>
              <label>Última execução pela tela</label>
              <strong>{{ formatarDataHoraIndicador(ultimaImportacaoOk) }}</strong>
            </div>
          </div>

          <div class="alert ok" *ngIf="importacaoIndicadoresCarregando">
            Importação em andamento. Aguarde a conclusão.
          </div>

          <div class="log-importacao" *ngIf="importacaoLogLinhas.length > 0">
            <div *ngFor="let linha of importacaoLogLinhas">{{ linha }}</div>
          </div>

          <div class="vazio" *ngIf="!importacaoIndicadoresCarregando && importacaoLogLinhas.length === 0">
            Nenhuma importação executada nesta sessão. Use o botão “Atualizar indicadores BCB/SGS”.
          </div>
        </section>
      </ng-container>

</main>
</div>
